import { Component, OnInit } from '@angular/core';
import { RetornoSelecao } from './../../../shared/gridview/RetornoSelecao';
import { Estado } from './../../../shared/shared/estado.enum';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-quartil',
  templateUrl: './quartil.component.html'
})
export class QuartilComponent implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;
  
  filtros = {};

  constructor() { }

  ngOnInit() {
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
      let date = new Date(selecionado.registro.data_inicio);
      selecionado.registro.data_inicio = {'year': date.getUTCFullYear(), 'month': date.getMonth() + 1, 'day': date.getDate()};
      date = new Date(selecionado.registro.data_fim);
      selecionado.registro.data_fim = { 'year': date.getUTCFullYear(), 'month': date.getMonth() + 1, 'day': date.getDate()};
      
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#quartil-filtro').modal();
  }

}
